import DOMPurify from "isomorphic-dompurify";

/**
 * SafeHtml — render admin-authored HTML safely.
 *
 * All the HTML blocks we render (house rules, privacy, terms, stay policy,
 * location-about, shoot intro, property descriptions) are authored by
 * authenticated admins through the CMS. That said, a compromised admin account
 * or a pasted rich-text blob from an external source could carry `<script>` or
 * `onerror` attributes. DOMPurify strips everything dangerous while keeping
 * formatting tags (p, strong, em, br, a, ul, ol, li, h2-h6, blockquote).
 *
 * Use this instead of raw `dangerouslySetInnerHTML` everywhere admin HTML
 * reaches the DOM.
 */
const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "strong", "b", "em", "i", "u", "s", "a", "span", "div",
    "ul", "ol", "li", "blockquote", "hr",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "table", "thead", "tbody", "tr", "th", "td",
  ],
  ALLOWED_ATTR: ["href", "target", "rel", "class", "style"],
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ["script", "iframe", "object", "embed", "form", "input", "style"],
  FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover"],
};

export default function SafeHtml({ html, className, testId }) {
  if (!html) return null;
  const clean = DOMPurify.sanitize(String(html), CONFIG);
  // eslint-disable-next-line react/no-danger
  return <div className={className} data-testid={testId} dangerouslySetInnerHTML={{ __html: clean }} />;
}
